import { createSlice } from "@reduxjs/toolkit";

import {
  compareInString,
  getName,
  getUpdatedMarketData
} from "../../../container/SportsBookNode/utils/common/functions";

const initialState = {
  loading: false,
  success: false,
  error: false,
  matchDetails: {},
  matchMarkets: {},
  matchMarketIds: [],
  reloaded: false,
  totalMarket: "",
  matchStats: {},
  marketLoading: false,
  page: 1,
  marketDiscriptionId: null
};

const ExtraMarketSlice = createSlice({
  name: "ExtraMarket",
  initialState,
  reducers: {
    getSingleMatchDetailsStart: (state, action) => {
      state.matchDetails = {};
      state.matchMarkets = {};
      state.matchMarketIds = [];
      state.loading = true;
      state.error = false;
      state.matchDetails.matchMarket = [];
    },
    getSingleMatchDetailsSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      if (action?.payload?.matchId) {
        state.matchDetails = {
          ...state.matchDetails,
          ...action?.payload,
          matchMarkets: []
        };
        state.matchStats = action?.payload?.extraDetails;
        state.totalMarket = action.payload?.totalMarket;
      }
    },
    getSingleMatchDetailsFailure: (state) => {
      state.matchDetails = {};
      state.matchMarkets = {};
      state.matchMarketIds = [];
      state.loading = false;
      state.error = true;
      state.matchDetails.matchMarket = [];
    },
    resetExtraMarket: (state) => {
      state.matchDetails = {};
      state.matchMarkets = {};
      state.matchMarketIds = [];
      state.loading = false;
      state.error = true;
      state.matchDetails.matchMarket = [];
    },
    setIsReloaded: (state, action) => {
      state.reloaded = action?.payload;
    },
    updateExtraMarketsWithSocketData: (state, action) => {
      if (action.payload?.extraDetails) {
        state.matchStats = action.payload?.extraDetails;
      }
      const matchObj = state.matchDetails;
      if (matchObj && !matchObj?.messageNumber) {
        matchObj.messageNumber = -1;
      }
      if (
        matchObj &&
        action?.payload &&
        matchObj?.messageNumber &&
        parseInt(matchObj?.messageNumber) <=
          parseInt(action?.payload?.messageNumber)
      ) {
        if (!state.matchDetails?.matchScoreResult?.length) {
          matchObj.matchScoreResult = [];
        }

        if (action?.payload) {
          action?.payload?.matchScoreResult?.forEach((newScore) => {
            const updatedScoreIndex = matchObj.matchScoreResult?.findIndex(
              (oldScore) => {
                return (
                  getName(oldScore?.type, "en") ===
                  getName(newScore?.type, "en")
                );
              }
            );

            if (updatedScoreIndex !== -1) {
              matchObj.matchScoreResult[updatedScoreIndex] = newScore;
            } else {
              matchObj.matchScoreResult.push(newScore);
            }
          });
          if (
            action?.payload?.matchMarkets &&
            action?.payload?.matchMarkets?.length
          ) {
            const updatedMarketWithOutcomes = getUpdatedMarketData(
              state?.matchMarkets,
              action?.payload?.matchMarkets,
              action?.payload?.betStatus
            );
            state.matchMarkets = updatedMarketWithOutcomes;
          }
          let ExtraMarketData = { ...action?.payload };
          delete ExtraMarketData.matchMarkets;
          delete ExtraMarketData.matchScoreResult;
          state.matchDetails = {
            ...state.matchDetails,
            ...ExtraMarketData,
            messageNumber: action?.payload?.messageNumber
          };
        }
      }
    },
    getExtraMarketsStart: (state, action) => {
      state.marketLoading = true;
      state.page = action?.payload?.page;
    },
    getExtraMarketsSuccess: (state, action) => {
      if (
        compareInString(
          action?.payload?.matchMarkets?.length,
          action?.payload?.limit
        )
      )
        state.hasNext = true;
      else state.hasNext = false;
      state.marketLoading = false;
      if (action?.payload?.page === 1) {
        state.matchMarketIds = action?.payload?.matchMarkets?.map((market) => {
          state.matchMarkets[market?.matchMarketId] = market;
          return market?.matchMarketId;
        });
      } else {
        if (action?.payload?.matchMarkets?.length) {
          const newMarketIds = action?.payload?.matchMarkets?.map((market) => {
            if (!state.matchMarkets?.[market?.matchMarketId])
              state.matchMarkets[market?.matchMarketId] = market;
            return market?.matchMarketId;
          });
          const prevAndNewMarketIds = new Set([
            ...state.matchMarketIds,
            ...newMarketIds
          ]);
          state.matchMarketIds = [...prevAndNewMarketIds];
        }
      }
    },
    getExtraMarketsFailure: (state) => {
      state.marketLoading = false;
    },
    setMarketDiscription: (state, action) => {
      state.marketDiscriptionId = action.payload?.marketId;
    }
  }
});

export const {
  setIsReloaded,
  getSingleMatchDetailsStart,
  getSingleMatchDetailsSuccess,
  getSingleMatchDetailsFailure,
  getExtraMarketsStart,
  getExtraMarketsSuccess,
  getExtraMarketsFailure,
  resetExtraMarket,
  updateExtraMarketsWithSocketData,
  setMarketDiscription
} = ExtraMarketSlice.actions;

export default ExtraMarketSlice.reducer;
